import { createFileRoute } from "@tanstack/react-router";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { faqPage } from "@/lib/schema";
import { content } from "@/lib/content";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { BuyerGuides } from "@/components/BuyerGuides";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { IsoCertifications } from "@/components/IsoCertifications";
import { FaqSection } from "@/components/FaqSection";
import { Footer } from "@/components/Footer";

// Arabic reviewed for clear MSA and claim parity; business disclosures still require owner evidence.
export const Route = createFileRoute("/ar/")({
  head: () => ({
    meta: [
      { title: "عراق سيرت — التحضير لشهادات الأيزو وتسجيل الموردين في العراق" },
      {
        name: "description",
        content:
          "دعم التحضير لشهادات الأيزو وتسجيل موردي النفط والغاز في العراق. نحدّد الجهة المانحة ونطاق الشهادة لكل طلب، ونتحقّق من مسار ISO 29001 بشكل منفصل.",
      },
      {
        property: "og:title",
        content: "عراق سيرت — التحضير لشهادات الأيزو وتسجيل الموردين في العراق",
      },
      {
        property: "og:description",
        content:
          "دعم التحضير لشهادات الأيزو وتسجيل موردي النفط والغاز في العراق. نحدّد الجهة المانحة ونطاق الشهادة لكل طلب، ونتحقّق من مسار ISO 29001 بشكل منفصل.",
      },
      { property: "og:url", content: absolute("/ar") },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:locale", content: "ar_IQ" },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: absolute("/ar") }, ...hreflangLinks("/")],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          faqPage(
            "/ar",
            content.faq.home.map((f) => ({ q: f.q.ar, a: f.a.ar })),
          ),
        ),
      },
    ],
  }),
  component: IndexAr,
});

function IndexAr() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="bg-background">
        <Hero />
        <IsoCertifications />
        <WhyChooseUs />
        <BuyerGuides />
        <FaqSection items={content.faq.home} />
      </main>
      <Footer />
    </div>
  );
}
